module.exports = __webpack_public_path__ + "static/feature-edit-43a8a5de4f473b4789e2938027e3e566.png";